module.exports = __webpack_public_path__ + "img/SKMJ_ladder2.435a0cbd.jpg";